import './EmployeeJourney.scss';

import useSelector from 'hooks/useSelector';
import ServiceJourneyContainer from 'pages/ServiceOffering/ServiceJourneyContainer';
import React from 'react';

const EmployeeJourney = () => {
    const employeeJourneyData = useSelector((state) => state.home.data?.employeeJourney);
    console.log('employeeJourneyData', employeeJourneyData);
    if (!employeeJourneyData) {
        return null;
    }

    return (
        <div className="employee-journey">
            <div className="employee-journey__header">{employeeJourneyData.title}</div>
            <div className="employee-journey__description">
                Click on each stage to discover the resources and support available to you
                throughout your journey at Wärtsilä.
            </div>
            <ServiceJourneyContainer journeySteps={employeeJourneyData.serviceJourneySteps} />
        </div>
    );
};

export default EmployeeJourney;
